/**
 * Remove all items from cart (cart drawer)
 * Works with: <a class="remove-all" data-cart-clear href="{{ routes.cart_clear_url }}">
 */
(() => {
  const CLEAR_SELECTOR = '[data-cart-clear]';

  // If your theme already has debounce globally, great.
  // If not, this tiny fallback prevents errors.
  const _debounce =
    typeof debounce === 'function'
      ? debounce
      : (fn, wait = 200) => {
          let t;
          return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(null, args), wait);
          };
        };

  async function clearCartAndRefresh(triggerEl) {
    const drawer = triggerEl.closest('cart-drawer');

    triggerEl.classList.add('loading');

    try {
      // Notes are optional; only include if the field exists
      const notesEl = document.getElementById('mini-cart__notes');
      const body = notesEl ? { note: notesEl.value } : undefined;

      const res = await fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: body ? JSON.stringify(body) : undefined,
      });

      if (!res.ok) throw new Error('Cart clear request failed');

      // Refresh the drawer if your theme supports it
      if (drawer && typeof drawer.refresh === 'function') {
        drawer.refresh();
      } else {
        // Fallback: reload the page/cart state
        window.location.href = theme.routes.cart_url || '/cart';
      }
    } catch (err) {
      console.error('[Remove All] Failed:', err);

      // Fallback: hard clear via navigation (works even if JS fails)
      window.location.href = theme.routes.cart_clear_url || '/cart/clear';
    } finally {
      triggerEl.classList.remove('loading');
    }
  }

  const debouncedHandler = _debounce((e) => {
    const btn = e.target.closest(CLEAR_SELECTOR);
    if (!btn) return;

    e.preventDefault();
    clearCartAndRefresh(btn);
  }, 200);

  document.addEventListener('click', debouncedHandler);
})();